import { styled } from "@mui/material";
import { BaseButton } from "components/buttons/BaseButton";
import { useEffect, useState } from "react";
import { UseFormGetValues, UseFormSetValue, FieldPath } from "react-hook-form";
import { useSelector } from "react-redux";
import { IAppState } from "../../../../../store/app-state";
import UploadSearch from "../../../../upload/UploadSearch";
import profile_icon from "../../../../icons/profile_gray.svg";
import tick from "../../../../icons/tick.svg";
import UploadNicheItem from "../../../../upload/UploadNicheItem";
import { useKeyPress } from "../../../../../hooks/useKeyPress";
import { ISignUpFieldValues } from "../AuthSignUp";

interface IProps {
  next: () => void;
  setValue: UseFormSetValue<ISignUpFieldValues>;
  getValues: UseFormGetValues<ISignUpFieldValues>;
  disabled: boolean;
}

const SignUpNichesStep = (props: IProps) => {
  const { setValue, getValues, disabled, next } = props;

  const niches = useSelector((state: IAppState) => state.niches.niches);
  const [filteredNiches, setFilteredNiches] = useState<any>(niches.niches ? niches.niches : []);
  const [selectedNiches, setSelectedNiches] = useState<any>(getValues().niches ? getValues().niches : []);

  const enterPressed = useKeyPress("Enter");

  const search = (value: string) => {
    if (niches.niches) {
      if (value) {
        const newNiches = niches.niches.filter((el: any) => el.name.toLowerCase().includes(value.toLowerCase()));
        setFilteredNiches(newNiches);
      } else {
        setFilteredNiches(niches.niches ? niches.niches : []);
      }
    }
  };

  const handleSelectNiche = (niche: any) => {
    const newSelectedNiches = [...selectedNiches];
    let isExist = false;

    newSelectedNiches.forEach((el, index) => {
      if (el === niche.id) {
        isExist = true;
        newSelectedNiches.splice(index, 1);
      }
    });

    if (!isExist) {
      newSelectedNiches.push(niche.id);
    }
    setSelectedNiches(newSelectedNiches);
  };

  const handleNext = () => {
    if (selectedNiches.length > 0) {
      next();
    }
  };

  useEffect(() => {
    setValue<FieldPath<ISignUpFieldValues>>("niches", selectedNiches);
    // eslint-disable-next-line
  }, [selectedNiches])

  useEffect(() => {
    if (enterPressed) {
      handleNext();
    }
    // eslint-disable-next-line
  }, [enterPressed])

  return (
    <Container>
      <Label>Select some Niches to personalise your experience:</Label>
      <UploadSearch onSearch={search}/>
      <NichesWrapper>
        {filteredNiches ? filteredNiches.map((el: any) => (
          <UploadNicheItem
            key={el.id}
            img={el.thumbnail}
            name={el.name}
            subscribers={el.subscribers}
            index={0}
            id={el.id}
            disabled={false}
            isSelected={!!selectedNiches.find((n: any) => n === el.id)}
            select={() => handleSelectNiche(el)}
            profile_icon={profile_icon}
            selected_icon={tick}
          />
        )) : <p style={{ fontSize: "14px" }}>We have some issues with loading niches. Please close and open the dialog and try again.</p>}
      </NichesWrapper>
      <StyledBaseButton>
        <BaseButton onClick={handleNext} disabled={selectedNiches.length < 1 || disabled}>Next</BaseButton>
      </StyledBaseButton>
    </Container>
  );
};

export default SignUpNichesStep;

const Container = styled("div")({
  marginTop: "2rem",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  height: "100%",
  "*": {
    fontFamily: "'Poppins', sans-serif!important",
  },
});

const Label = styled("label")({
  fontWeight: "500",
  fontSize: "14px"
});

const NichesWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  overflowY: "auto",
  paddingBottom: "100px",
  maxHeight: "300px",
  ".phone &, .tablet &": {
    maxHeight: "260px"
  },
  "&::-webkit-scrollbar": {
    display: "none"
  },
  "& > div": {
    width: "100%",
    padding: "0 16px 0 0"
  },
  "& div": {
    opacity: 1
  },
  "& > div div + div img": {
    width: "12px",
    position: "relative",
    top: "2px"
  },
  "& span": {
    opacity: 0.3
  }
});

const StyledBaseButton = styled("div")({
  position: "absolute",
  bottom: "0",
  left: "0",
  width: "100%",
  padding: "16px 16px 32px",
  background: "rgba(255, 255, 255, 0.9)",
  borderRadius: "24px"
});
